export default __webpack_public_path__ + "static/media/pic12.15796376.jpg";